import React from 'react';
import BasicCard from '../components/BasicCard';
import HubSpotNewClientForm from '../components/HubSpotNewClientForm';
import styles from '../styles/NewClient.module.css';
import { Helmet } from 'react-helmet-async';

export default function NewClientQuestionnaire() {
    return (
        <>
            <Helmet>
                <title>Packages | Meshae Studios</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <main className={styles.pageContainer}>
                {/*
                  pageLayout: two-track grid (80px index rail | 1fr content).
                  The rail's border-right is the same --rule as the navbar logo cell
                  and footer index cell — so the vertical line is continuous on every page.
                */}
                <div className={styles.pageLayout}>

                    {/* Index rail — rotated label + continuous vertical rule */}
                    <div className={styles.indexRail} aria-hidden="true">
                        <span className={styles.indexRailLabel}>Jacksonville, FL - Video Production, Web Design and Development, IT Support </span>
                    </div>

                    {/* Right track: all page content */}
                    <div className={styles.mainContent}>
                        <div className={styles.formGrid}>
                            <BasicCard
                                className={styles.card}
                                header={
                                    <div className={styles.headerLayout}>
                                        {/* Left 6 cols: kicker + display title */}
                                        <div className={styles.headingGroup}>
                                            <span className={styles.headingKicker}>Let's talk</span>
                                            <h1 className={styles.headingMain}>
                                                Have a project in mind?
                                            </h1>
                                        </div>

                                    </div>
                                }
                                headerClassName={styles.cardHeader}
                                bodyClassName={styles.cardBody}
                            >
                                <div className={styles.copyGrid}>
                                    <aside className={styles.clientInfoBlock} aria-label="Questionnaire information">
                                        <div className={styles.clientInfoSticky}>
                                            <span className={styles.infoKicker}>Start creating.</span>


                                            <p className={styles.infoCopy}>
                                                Tell us about your brand, goals, timeline, and the support you
                                                need.
                                            </p>

                                            <div className={styles.processList}>
                                                <div className={styles.processItem}>
                                                    <span className={styles.processNumber}>01</span>
                                                    <span className={styles.processText}>
                                                        Complete the questionnaire
                                                    </span>
                                                </div>

                                                <div className={styles.processItem}>
                                                    <span className={styles.processNumber}>02</span>
                                                    <span className={styles.processText}>
                                                        We review your project details
                                                    </span>
                                                </div>

                                                <div className={styles.processItem}>
                                                    <span className={styles.processNumber}>03</span>
                                                    <span className={styles.processText}>
                                                        We follow up with next steps
                                                    </span>
                                                </div>
                                            </div>

                                            <a
                                                href="mailto:admin@meshaestudios.com"
                                                className={styles.emailItem}
                                            >
                                                <span className={styles.contactIcon} aria-hidden="true">
                                                    <svg viewBox="0 0 24 24" fill="none">
                                                        <rect x="3" y="5" width="18" height="14" rx="1" />
                                                        <path d="m4 7 8 6 8-6" />
                                                    </svg>
                                                </span>

                                                <span className={styles.emailText}>
                                                    <span className={styles.emailLabel}>Questions first?</span>
                                                    <span className={styles.emailValue}>
                                                        admin@meshaestudios.com
                                                    </span>
                                                </span>
                                            </a>
                                        </div>
                                    </aside>
                                    <div className={styles.formBlock}>
                                        <HubSpotNewClientForm />
                                    </div>
                                </div>
                            </BasicCard>
                        </div>
                    </div>{/* end .mainContent */}

                </div>{/* end .pageLayout */}
            </main>
        </>
    );
}